module.exports = __webpack_public_path__ + "static/mark-ritchie-logo-440dcaaa940c26697ad98e662169e8e0.svg";